import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowRight, Clock, User } from 'lucide-react';
import { blogPosts } from '../data/blogData';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" data-testid="blog-page">
      {/* Hero */}
      <div className="bg-black text-white py-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-sm text-red-500 font-semibold tracking-widest mb-4">ACE JOURNAL</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4" data-testid="blog-hero-title">
            Auto Lifestyle <em className="text-red-500 not-italic">Journal</em>
          </h1>
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto">
            Market intelligence, auto lifestyle insights, and ACE perspectives — by the Auto Concierge team.
          </p>
        </div>
      </div>

      {/* Featured Post */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <Card
          className="overflow-hidden border-gray-200 hover:shadow-xl transition-all cursor-pointer"
          onClick={() => navigate(`/blog/${blogPosts[0].slug}`)}
          data-testid="featured-blog-post"
        >
          <div className="grid md:grid-cols-2">
            <div className="bg-black p-10 flex flex-col justify-center">
              <span className="text-xs font-bold text-red-500 tracking-widest mb-3">{blogPosts[0].category.toUpperCase()} — FEATURED</span>
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 leading-tight">{blogPosts[0].title}</h2>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">{blogPosts[0].excerpt}</p>
              <div className="flex items-center gap-4 text-xs text-gray-500">
                <span className="flex items-center gap-1"><User className="h-3 w-3" /> {blogPosts[0].author}</span>
                <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {blogPosts[0].readTime}</span>
                <span>{blogPosts[0].date}</span>
              </div>
            </div>
            <div className="bg-gradient-to-br from-red-600 to-red-900 p-10 flex items-center justify-center min-h-[300px]">
              <div className="text-center text-white">
                <p className="text-6xl font-bold opacity-20 mb-2">ACE</p>
                <p className="text-sm tracking-widest opacity-60">JOURNAL</p>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* All Posts Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-24">
        <h2 className="text-2xl font-bold text-black mb-8">All Articles</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, idx) => (
            <Card
              key={idx}
              className="overflow-hidden border-gray-200 hover:shadow-xl transition-all cursor-pointer group"
              onClick={() => navigate(`/blog/${post.slug}`)}
              data-testid={`blog-post-card-${idx}`}
            >
              <div className="h-3 bg-red-600" />
              <div className="p-6">
                <span className="text-xs font-bold text-red-600 tracking-wider">{post.category.toUpperCase()}</span>
                <h3 className="text-lg font-bold text-black mt-2 mb-3 group-hover:text-red-600 transition-colors leading-snug">{post.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-gray-500">
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                  <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-red-600 transition-colors" />
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold text-black mb-3">Want more ACE insights?</h2>
          <p className="text-gray-600 mb-6">Subscribe to the ACE newsletter for auto lifestyle intelligence delivered to your inbox.</p>
          <Button onClick={() => navigate('/')} className="bg-black hover:bg-red-600 text-white">
            Subscribe on Homepage
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Blog;
